import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-time-picker-input',
  templateUrl: './time-picker-input.component.html',
  styleUrls: ['./time-picker-input.component.scss'],
})
export class TimePickerInputComponent {
  @Input() label = '';
  @Input() value: string | null = null; // HH:mm

  @Output() valueChange = new EventEmitter<string>();

  modalOpen = false;

  /** Converte ISO → HH:mm */
  isoToTime(iso: string): string {
    const date = new Date(iso);
    return date.toISOString().substring(11, 16);
  }

  /** Converte HH:mm → ISO (per ion-datetime) */
  timeToIso(time: string): string {
    return `1970-01-01T${time}:00`;
  }

  onDesktopChange(val: string | string[] | null | undefined) {
    if (typeof val !== 'string') {
      return;
    }
    this.value = val;
    this.valueChange.emit(val);
  }

  onMobileConfirm(iso: string | string[] | null | undefined) {
    if (typeof iso !== 'string') {
      this.modalOpen = false;
      return;
    }
    const time = this.isoToTime(iso);
    this.value = time;
    this.valueChange.emit(time);
    this.modalOpen = false;
  }
}
